import React from 'react';
import { IHTCalculation } from '../../types';

interface Props {
    ihtCalc?: IHTCalculation | null;
}

export const ValidationGuardBanner: React.FC<Props> = ({ ihtCalc }) => {
    const validation = ihtCalc?.validation;
    if (!validation || validation.valid) return null;

    const errors = validation.issues.filter(i => i.severity === 'error');
    const warnings = validation.issues.filter(i => i.severity === 'warning');

    return (
        <div className="bg-white border border-[#1A1A1A] rounded overflow-hidden">
            <div className="px-6 py-4 border-b border-[#1A1A1A]">
                <h2 className="font-serif text-[22px] font-normal tracking-[-0.01em] text-[#1A1A1A] m-0">
                    Calculation inconsistency detected
                </h2>
                <p className="text-[13px] font-serif italic text-[#3F3D39] mt-1">
                    Please review the estate inputs. The tax result may not be reliable.
                </p>
            </div>

            <div className="p-6 space-y-2">
                {errors.map((issue, i) => (
                    <div key={issue.code + i} className="border-b border-dotted border-[#E8E4DB] py-2 last:border-0">
                        <span className="text-[10px] tracking-[0.18em] uppercase text-[#6B6762] font-mono tabular-nums">{issue.code}</span>
                        <p className="text-[13px] font-serif italic text-[#1A1A1A] mt-0.5 leading-relaxed">{issue.message}</p>
                    </div>
                ))}
                {warnings.map((issue, i) => (
                    <div key={issue.code + i} className="border-b border-dotted border-[#E8E4DB] py-2 last:border-0">
                        <span className="text-[10px] tracking-[0.18em] uppercase text-[#6B6762] font-mono tabular-nums">{issue.code}</span>
                        <p className="text-[13px] text-[#3F3D39] mt-0.5 leading-relaxed">{issue.message}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
